// Symbol,Name,Last Trade,Change,Volume
// prettier-ignore
export default [
    ["AAL.L","Anglo American  PLC","436.35 13:13","5.35 (1.24%)","5,799,089"],
    ["ABF.L","Associated British Foods  PLC","3,435.60 13:12","7.40 (0.21%)","86,808"],
    ["ADM.L","Admiral Group  PLC","1,627.00 13:13",""],
    ["ADN.L","Aberdeen Asset Management  PLC","334.00 13:13","2.50 (0.75%)","806,880"],
    ["AHT.L","Ashtead Group  PLC","1,027.00 13:13","6.00 (0.59%)","331,255"],
    ["ANTO.L","Antofagasta  PLC","484.10 13:13","11.70 (2.48%)","1,753,976"],
    ["ARM.L","ARM Holdings  PLC","1,058.00 13:13","3.00 (0.28%)","475,927"],
    ["AV.L","Aviva  PLC","493.97 13:13","2.23 (0.45%)","2,226,835"],
    ["AZN.L","AstraZeneca  PLC","4,399.50 13:13","2.50 (0.06%)","815,133"],
    ["BA.L","BAE Systems  PLC","478.10 13:13","4.30 (0.91%)","2,039,934"],
    ["BAB.L","Babcock International Group  PLC","988.00 13:13","9.50 (0.97%)","209,614"],
    ["BARC.L","Barclays  PLC","226.30 13:13", "1.15 (0.51%)","6,575,664"],
    ["BATS.L","British American Tobacco  PLC","3,803.50 13:13", "8.50 (0.22%)","465,110"],
    ["BDEV.L","Barratt Developments  PLC","576.00 13:13", "0.50 (0.09%)","1,044,365"],
    ["BG.L","BG Group  PLC","1,013.50 13:13", "5.50 (0.55%)","1,507,332"],
    ["BKG.L","Berkeley Group Holdings (The)  PLC","3,126.00 13:13", "15.00 (0.48%)","95,071"],
    ["BLND.L","British Land Co  PLC","828.06 13:12", "10.44 (1.25%)","1,802,548"],
    ["BLT.L","BHP Billiton  PLC","881.40 13:13", "4.30 (0.49%)","4,947,287"],
    ["BNZL.L","Bunzl  PLC","1,875.40 13:05", "4.60 (0.24%)","104,541"],
    ["BP.L","BP  PLC","381.50 13:13", "2.95 (0.78%)","10,493,561"],
    ["BRBY.L","Burberry Group  PLC","1,269.00 13:13", "7.00 (0.55%)","295,647"],
    ["BT-A","L,BT Group  PLC","489.20 13:13", "3.70 (0.75%)","3,914,982"],
    ["CCL.L","Carnival  PLC","3,426.00 13:12", "22.00 (0.64%)","86,257"],
    ["CNA.L","Centrica  PLC","212.80 13:13", "0.60 (0.28%)","2,144,540"],
    ["CPG.L","Compass Group  PLC","1,054.00 13:08", "5.00 (0.48%)","1,001,167"],
    ["CPI.L","Capita  PLC","1,235.00 13:11", "1.00 (0.08%)","244,591"],
    ["CRH.L","CRH  PLC","1,783.20 13:12", "17.80 (0.99%)","897,325"],
    ["DC.L","DIXONS CARPHONE","462.10 13:11",""],
    ["DGE.L","Diageo  PLC","1,881.50 13:13", "6.50 (0.34%)","756,906"],
    ["DLG.L","Direct Line Insurance Group  PLC","403.80 13:13", "0.40 (0.10%)","1,095,340"],
    ["EXPN.L","Experian  PLC","1,191.00 13:12", "2.00 (0.17%)","467,283"],
    ["EZJ.L","easyJet  PLC","1,682.00 13:12", "28.00 (1.64%)","1,191,230"],
    ["FRES.L","Fresnillo  PLC","678.50 13:12", "6.50 (0.97%)","381,871"],
    ["GFS.L","G4S  PLC","232.30 13:03", "2.00 (0.85%)","1,096,551"],
    ["GKN.L","GKN  PLC","294.80 13:12", "2.50 (0.86%)","792,247"],
    ["GLEN.L","Glencore  PLC","90.48 13:13", "1.65 (1.86%)","41,631,528"],
    ["GSK.L","GlaxoSmithKline  PLC","1,345.00 13:13", "0.50 (0.04%)","1,767,356"],
    ["HIK.L","Hikma Pharmaceuticals  PLC","2,010.00 13:04", "57.00 (2.92%)","261,511"],
    ["HL.L","Hargreaves Lansdown  PLC","1,488.03 13:12", "9.97 (0.67%)","372,261"],
    ["HMSO.L","Hammerson  PLC","597.50 13:11", "3.50 (0.58%)","478,301"],
    ["HSBA.L","HSBC Holdings  PLC","519.70 13:13", "0.50 (0.10%)","7,415,629"],
    ["IAG.L","International Consolidated Airlines Group SA","575.40 13:12", "16.10 (2.72%)","4,311,514"],
    ["IHG.L","InterContinental Hotels Group  PLC","2,481.00 13:12", "19.00 (0.76%)","219,918"],
    ["III.L","3i Group  PLC","487.30 13:11", "4.50 (0.92%)","189,987"],
    ["IMT.L","Imperial Tobacco Group  PLC","3,571.00 13:13", "29.00 (0.81%)","926,816"],
    ["INTU.L","intu properties  PLC","319.90 13:09", "4.60 (1.42%)","514,821"],
    ["ISAT.L","Inmarsat  PLC","1,054.44 13:13", "3.44 (0.33%)","988,089"],
    ["ITRK.L","Intertek Group  PLC","2,643.00 13:14", "3.00 (0.11%)","45,868"],
    ["ITV.L","ITV  PLC","267.30 13:14", "2.60 (0.96%)","3,453,208"],
    ["JMAT.L","Johnson Matthey  PLC","2,445.00 13:14", "29.00 (1.20%)","276,397"],
    ["KGF.L","Kingfisher  PLC","346.20 13:14", "4.30 (1.23%)","1,021,408"],
    ["LAND.L","Land Securities Group  PLC","1,239.00 13:13", "7.00 (0.56%)","384,973"],
    ["LGEN.L","Legal & General Group  PLC","266.00 13:14", "1.60 (0.60%)","1,998,399"],
    ["LLOY.L","Lloyds Banking Group  PLC","73.86 13:14", "0.02 (0.03%)","18,907,878"],
    ["LSE.L","London Stock Exchange Group  PLC","2,544.00 13:11", "6.00 (0.24%)","129,657"],
    ["MGGT.L","Meggitt  PLC","386.00 13:15", "3.20 (0.84%)","611,044"],
    ["MKS.L","Marks & Spencer Group  PLC","514.75 13:12", "3.25 (0.63%)","920,128"],
    ["MNDI.L","Mondi  PLC","1,463.00 13:14", "7.00 (0.48%)","383,546"],
    ["MRW.L","Morrison (Wm) Supermarkets  PLC","155.20 13:14",""],
    ["NG.L","National Grid  PLC","926.40 13:14", "1.10 (0.12%)","1,659,592"],
    ["NXT.L","Next  PLC","7,765.00 13:11", "95.00 (1.21%)","114,062"],
    ["OML.L","Old Mutual  PLC","198.50 13:14", "0.40 (0.20%)","2,040,849"],
    ["PRU.L","Prudential  PLC","1,499.50 13:15", "14.00 (0.93%)","580,870"],
    ["PSON.L","Pearson  PLC","794.00 13:09", "5.00 (0.63%)","1,177,953"],
    ["RB.L","Reckitt Benckiser Group  PLC","6,293.00 13:14", "34.00 (0.54%)","281,172"],
    ["RBS.L","Royal Bank of Scotland Group  PLC","313.40 13:14", "2.40 (0.77%)","2,100,058"],
    ["RDSA.L","Royal Dutch Shell  PLC","1,636.00 13:14", "18.00 (1.11%)","2,467,461"],
    ["RDSB.L","Royal Dutch Shell  PLC","1,652.00 13:15", "14.50 (0.89%)","1,457,434"],
    ["REL.L","Reed Elsevier  PLC","1,170.00 13:14","0.00 (0.00%)","908,802"],
    ["RIO.L","Rio Tinto  PLC","2,235.00 13:15", "21.00 (0.95%)","2,190,722"],
    ["RMG.L","Royal Mail  PLC","453.50 13:14", "1.20 (0.26%)","995,316"],
    ["RR.L","Rolls-Royce Group  PLC","546.63 13:14", "8.38 (1.51%)","2,792,915"],
    ["RRS.L","Randgold Resources Ltd","3,929.00 13:14","0.00 (0.00%)","135,524"],
    ["RSA.L","RSA Insurance Group  PLC","437.10 13:14", "0.10 (0.02%)","395,477"],
    ["SAB.L","SABMiller  PLC","4,011.00 13:15", "1.00 (0.02%)","892,451"],
    ["SBRY.L","Sainsbury (J)  PLC","255.80 13:14", "7.40 (2.98%)","2,395,670"],
    ["SDR.L","Schroders  PLC","2,930.00 13:09", "12.00 (0.41%)","44,674"],
    ["SGE.L","Sage Group (The)  PLC","545.50 13:13", "0.50 (0.09%)","539,717"],
    ["SHP.L","Shire  PLC","4,685.00 13:14", "22.00 (0.47%)","221,318"],
    ["SKY.L","SKY","1,095.00 13:12", "4.00 (0.37%)","925,016"],
    ["SL.L","Standard Life  PLC","399.90 13:14", "3.20 (0.79%)","861,636"],
    ["SMIN.L","Smiths Group  PLC","992.50 13:14", "27.50 (2.70%)","640,309"],
    ["SN.L","Smith & Nephew  PLC","1,110.00 13:14", "9.00 (0.82%)","480,018"],
    ["SPD.L","Sports Direct International  PLC","694.50 13:11", "1.50 (0.22%)","157,981"],
    ["SSE.L","SSE  PLC","1,463.00 13:13", "2.00 (0.14%)","562,454"],
    ["STAN.L","Standard Chartered  PLC","583.00 13:14", "0.60 (0.10%)","2,018,697"],
    ["STJ.L","St James's Place  PLC","964.00 13:14", "11.00 (1.13%)","418,480"],
    ["SVT.L","Severn Trent  PLC","2,199.00 13:12", "1.00 (0.05%)","95,342"],
    ["TPK.L","Travis Perkins  PLC","1,945.00 13:13", "4.00 (0.21%)","92,916"],
    ["TSCO.L","Tesco  PLC","171.54 13:14", "2.54 (1.50%)","9,831,136"],
    ["TUI.L","TUI AG","1,115.00 13:10", "5.00 (0.45%)","458,970"],
    ["TW.L","Taylor Wimpey  PLC","183.90 13:15", "1.10 (0.59%)","3,180,729"],
    ["ULVR.L","Unilever  PLC","2,791.00 13:14", "29.00 (1.03%)","824,827"],
    ["UU.L","United Utilities Group  PLC","959.00 13:10", "2.50 (0.26%)","436,911"],
    ["VOD.L","Vodafone Group  PLC","224.25 13:15", "1.30 (0.58%)","17,572,036"],
    ["WOS.L","Wolseley  PLC","3,657.00 13:14", "4.00 (0.11%)","179,536"],
    ["WPP.L","WPP  PLC","1,502.00 13:15", "12.00 (0.79%)","857,887"],
    ["WTB.L","Whitbread  PLC","4,484.00 13:16", "60.00 (1.32%)","141,036"]
]
